import { useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";
import { Textarea } from "~/components/ui/textarea";
import { Agent } from "~/services/agents";

const schema = yup.object({
  display_name: yup.string().trim().required("Name is required"),
  description: yup.string().defined(),
});

type FormValues = yup.InferType<typeof schema>;

export const AgentProfileTab = () => {
  const agent = useOutletContext<Agent>();

  const {
    register,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      display_name: agent.display_name,
      description: agent.description ?? "",
    },
  });

  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-4">
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="display_name">Name</Label>
        <Input
          id="display_name"
          disabled
          aria-invalid={!!errors.display_name}
          {...register("display_name")}
        />
      </div>

      <div className="flex flex-col gap-1.5">
        <Label htmlFor="description">Description</Label>
        <Textarea id="description" rows={3} disabled {...register("description")} />
      </div>

      {agent.persona && (
        <div className="flex flex-col gap-1.5">
          <Label>Persona</Label>
          <Textarea value={agent.persona} rows={10} disabled className="resize-none" readOnly />
        </div>
      )}
    </div>
  );
};
